import {
  CSSObject,
  getFontWeight,
  Theme,
  forBrands,
} from '@core-ui/react-stitch';
import getControlBeforeStyles from '../getControlBeforeStyles';


const setBackgroundColorForBR = (theme: Theme,isBRcolor2023FFEnabled:boolean) =>
     isBRcolor2023FFEnabled ? "#F6F4EB":theme.color.inverse.b1


const setControlStylesForBananaRepublic = (theme: Theme,isBRcolor2023FFEnabled:boolean): CSSObject => ({
  textAlign: 'left',
  color: isBRcolor2023FFEnabled ? "#000000" : theme.color.b2,
  backgroundColor: setBackgroundColorForBR(theme,isBRcolor2023FFEnabled),
  width: '6.25rem',
  padding: '0.375rem',
  borderBottom: isBRcolor2023FFEnabled ? "0.063rem solid #000000" : `0.063rem solid ${theme.color.b2}`,
  '&::before': {
    ...getControlBeforeStyles(theme,isBRcolor2023FFEnabled),
    backgroundPositionX: '0.5rem',
    backgroundPositionY: '1rem',
  },
  '&:hover': {
    backgroundColor: theme.color.wh,
    animation: 'none !important',
    outline: 'none',
  },
  '&:focus': {
    animation: 'none !important',
    outline: 'none',
  },
  fontWeight: getFontWeight('regular').fontWeight,
  fontSize: '1rem',
});


const getControlStyles =
  (isBRcolor2023FFEnabled:boolean) =>
  (base: CSSObject, { theme }: { theme: Theme }): CSSObject => ({
    ...base,
    color: theme.color.b1,
    marginTop: 0,
    position: 'relative',
    width: '100%',
    textAlign: 'center',
    '&::before': {
      ...getControlBeforeStyles(theme,isBRcolor2023FFEnabled),
      width: '0.5rem',
      right: '-0.5rem',
      backgroundSize: '100% auto',
      backgroundPositionX: 'right',
      marginLeft: '0.5rem',
      marginRight: '0.5rem',
    },
    ...(forBrands(theme, {
      br: setControlStylesForBananaRepublic(theme,isBRcolor2023FFEnabled),
      brfs: setControlStylesForBananaRepublic(theme,isBRcolor2023FFEnabled),
    }) as CSSObject),
  });

export default getControlStyles;
